import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";



export default function AdminDashboard() {

  const [portfolioCount, setPortfolioCount] = useState(0);
  const [adminCount, setAdminCount] = useState(0);

  useEffect(() => {
    // PORTFOLIO COUNT
    axios.get("https://apnaqwebx-mern.onrender.com/api/counter/portfolio")
      .then(res => setPortfolioCount(res.data.count))
      .catch(err => console.log(err));

    // ADMIN COUNT
    axios.get("https://apnaqwebx-mern.onrender.com/api/counter/admin")
      .then(res => setAdminCount(res.data.count))
      .catch(err => console.log(err));
  }, []);

 


  return (<>
    {/* PAGE CONTENT */}
    <div className="p-6 mt-7 pt-44 md:pt-5">

      {/* PAGE TITLE */}
      <h1 className="text-3xl font-vollkorn text-[#895712] font-bold text-brandBlue md:mt-20 mb-8">
        Admin Dashboard
      </h1>

      {/* ======= TOP CARDS ======= */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

        {/* TOTAL PRODUCTS */}
        <Link to="/admin/portfoliolist">
          <div className="group bg-white shadow-md rounded-xl p-6 border border-[#895712] flex items-center gap-5 hover:shadow-xl transition cursor-pointer">
            <div className="bg-blue text-[#895712] p-4 rounded-lg group-hover:scale-110 transition">
              <i className="fa-solid fa-box text-2xl"></i>
            </div>
            <div>
              <p className="text-[#895712] text-xl">Total Portfolio</p>
              <h2 className="text-2xl font-bold font-vollkorn">
                {portfolioCount}
              </h2>
            </div>
          </div>
        </Link>



        {/* ADMIN USERS */}
        <Link to="/admin/adminlist">
          <div className="group bg-white shadow-md rounded-xl p-6 border border-[#895712] flex items-center gap-5 hover:shadow-xl transition cursor-pointer">
            <div className="bg-blue text-[#895712] p-4 rounded-lg group-hover:scale-110 transition">
              <i className="fa-solid fa-users text-2xl"></i>
            </div>
            <div>
              <p className="text-[#895712] text-xl">Admin Users</p>
              <h2 className="text-2xl font-bold font-vollkorn">
                {adminCount}
              </h2>
            </div>
          </div>
        </Link>


      </div>

      {/* ======= BOTTOM OVERVIEW BOX ======= */}
      <div className="bg-white rounded-xl shadow-md p-6 mt-10 border border-[#895712]">
        <h2 className="text-lg font-semibold text-blue mb-3 text-[#895712]">
          Quick Overview
        </h2>
        <p className="text-grey leading-relaxed">
          Welcome to your admin panel. Use the sidebar to manage products,
          gallery images, and update website content. This dashboard provides
          a quick snapshot of important activity and system information.
        </p>
      </div>

    </div> </>
  );
}
